import React from 'react'
import { Resume } from 'packages/types'
import { SettingsFieldChangeHandler } from '../../../../../modules/resumeEditor'
import { useTemplateCustomization } from './useTemplateCustomization'

const MAP_FIELD_NAME_TO_SETTINGS_FIELD = {
  skillsLayout: 'supportsSkillsLayouts',
  educationLayout: 'supportsEducationLayouts',
  educationOrder: 'supportsEducationOrder',
} as const

export function useLayoutBlockCustomisation(
  field: 'skillsLayout' | 'educationLayout' | 'educationOrder',
  resume: Resume,
  onFieldChange?: SettingsFieldChangeHandler,
) {
  const { currentTemplate, resumeSpecificTemplateSettings } = useTemplateCustomization(resume)
  const defaultSettings = currentTemplate?.settings
  const currentSettings = resumeSpecificTemplateSettings

  const supportsField = MAP_FIELD_NAME_TO_SETTINGS_FIELD[field]

  const defaultFieldSettings = defaultSettings?.[field]
  const defaultField = defaultFieldSettings?.find(option => option.isDefault)

  return {
    value: currentSettings?.[field] || defaultField?.value,
    isDisabled: !currentTemplate?.[supportsField],
    isFieldOptionDisabled: (optionValue: string) => {
      const option = defaultFieldSettings?.find(opt => opt.value === optionValue)
      return option?.isDisabled || false
    },
    onSelect: (event: React.ChangeEvent<HTMLInputElement>) => {
      const name = event.target.name as keyof typeof resumeSpecificTemplateSettings
      const newValue = event.target.value
      const oldValue = currentSettings?.[field]
      onFieldChange?.(name, newValue, oldValue)
    },
  }
}
